<template>
  <div
    class="p-5"
    :class="[
      'has-border-radius',
      hasWhiteBackground ? 'has-background-white' : 'has-background-light'
    ]"
  >
    <div class="is-flex is-justify-content-space-between is-align-items-start mb-2">
      <span class="has-text-weight-medium is-size-3">{{ title }}</span>
      <IconView :icon="icon" type="is-primary" custom-class="is-size-2" />
    </div>
    <p class="is-size-4 feature-card-description">{{ description }}</p>
    <slot name="action" />
  </div>
</template>

<script>
import IconView from '@/modules/core/ui/components/wrappers/IconView.vue';

export default {
  name: 'FinancialAdvisorUpsellFeatureCard',
  components: {
    IconView
  },
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    hasWhiteBackground: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.feature-card-description {
  white-space: pre-line;
}
</style>
